import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Base from "../../Config/Base";
import "../../../Assets/popup.css";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../Config/search.css";
import "../../Config/loader.css";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";
import { useNavigate } from "react-router-dom";
export default function Customers() {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const [customersData, setCustomersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { setID } = useLabelContext();
  const [customerCounts, setCustomerCounts] = useState({
    activeClients: 0,
    totalClients: 0,
    reminders: 0,
    proposals: 0,
  });
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}customers/GetCustomers`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setCustomersData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setCustomersData([]); // Set an empty array to avoid errors
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    getCustomerCounts();
  }, []);

  const getCustomerCounts = async () => {
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetCustomersCounts`,
      );

      const result = await response.json();

      if (result.Status && result.ResultData.length > 0) {
        const counts = result.ResultData[0];

        setCustomerCounts({
          activeClients: counts.ActiveClients,
          totalClients: counts.TotalClients,
          reminders: counts.Reminders,
          proposals: counts.Proposals,
        });
      }
    } catch (error) {
      console.error("Error fetching customer counts:", error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const filteredItems = useMemo(() => {
    const results = customersData.filter(
      (item) =>
        (item.vat && item.vat.toString().includes(searchTerm.toString())) ||
        (item.company &&
          item.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.city &&
          item.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.phonenumber &&
          item.phonenumber.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    setCurrentPage(1);

    return results;
  }, [customersData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleExcelDownload = () => {
    if (customersData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    const wsData = customersData.map((item) => ({
      Company: item.company,

      "Date Created": formatDate(item.datecreated),
      City: item.city,
      State: item.state,
      Zipcode: item.zip,
      Website: item.website,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    XLSX.utils.book_append_sheet(wb, ws, "CustoemrsData");

    XLSX.writeFile(wb, "CustoemrsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    doc.setProperties({
      title: "Customers Data",
    });

    const tableData = [];

    const headers = [
      "Company",
      "Phone Number",
      "email",
      "Created Date",
      "City",
      "Website",
    ];
    tableData.push(headers);

    // Add rows
    customersData.forEach((item) => {
      const row = [];
      row.push(
        item.company,
        item.phonenumber,
        item.email,
        formatDate(item.datecreated),
        item.city,
        item.website,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("CustomersData.pdf");
  };

  const handleReload = () => {
    window.location.reload();
  };

  const toggleActiveStatus = async (userId, currentStatus) => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}ActiveCustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ UserId: userId, active: currentStatus ? 0 : 1 }),
      });

      const result = await response.json();

      if (result.Status) {
        setCustomersData((prevCustomers) =>
          prevCustomers.map((customer) =>
            customer.userid === userId
              ? { ...customer, active: currentStatus ? 0 : 1 }
              : customer,
          ),
        );
        Swal.fire("Success", "Customer status updated successfully", "success");
      } else {
        Swal.fire("Error", "Failed to update customer status", "error");
      }
    } catch (error) {
      console.error("Error updating customer status:", error);
      Swal.fire(
        "Error",
        "An error occurred while updating customer status",
        "error",
      );
    }
  };

  const handleViewPurchaseOrders = (item) => {
    console.log(item.userid, "uuuuuuuuuuuuuuuuuuuuuuuuu");
    setID(item.userid);
  };

  // console.log("Customer ID:", item.userid);

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Customers </h4>
            <h6>Manage your Customers</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
              <li>
                <Link
                  to="/add-customer"
                  className="btn btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="row g-3 align-items-center my-2">
          <div className="col-4 m-0">
            <div
              className="card shadow text-center mb-2"
              style={{ borderRadius: "15px" }}
            >
              <div className="card-body">
                <p className="card-title mb-2">
                  <i className="fa-solid fa-users fa-lg text-success"></i>
                </p>
                <h5 className="card-text fw-bold text-success">
                  {customerCounts.activeClients}/{customerCounts.totalClients}
                </h5>
                <p className="small text-muted">Active</p>
              </div>
            </div>
          </div>

          <div className="col-4 m-0">
            <div
              className="card shadow text-center mb-2"
              style={{ borderRadius: "15px" }}
            >
              <div className="card-body">
                <p className="card-title mb-2">
                  <i className="fa-solid fa-user-check fa-lg text-warning"></i>
                </p>
                <h5 className="card-text fw-bold text-warning">
                  {customerCounts.reminders}
                </h5>
                <p className="small text-muted">Follow-Ups</p>
              </div>
            </div>
          </div>

          <div className="col-4 m-0">
            <div
              className="card shadow text-center mb-2"
              style={{ borderRadius: "15px" }}
            >
              <div className="card-body">
                <p className="card-title mb-2">
                  <i className="fa-solid fa-file-signature fa-lg text-secondary"></i>
                </p>
                <h5 className="card-text fw-bold text-secondary">
                  {customerCounts.proposals}
                </h5>
                <p className="small text-muted">Proposals</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 mb-3">
        <div className="input-group">
          <input
            type="text"
            name="search"
            placeholder="Search..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="input-group-text bg-primary" id="basic-addon1">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </div>
      </div>
      {/* Responsive Wrapper for Table */}

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : currentItems && currentItems.length > 0 ? (
          currentItems.map((item, index) => (
            <div key={index} className="col-xl-4 col-lg-6 col-md-6">
              <div className="card mb-1 rounded-4">
                <div className="card-body">
                  <h5 className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "50%",
                          backgroundColor: "#E3F2FD",
                          color: "#0a0a0a",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          marginRight: "8px",
                          textTransform: "uppercase",
                        }}
                      >
                        {item?.company?.trim()
                          ? item.company.trim().substring(0, 2)
                          : "NA"}
                      </div>
                      <Link
                        className="d-flex flex-column"
                        to="/view-customer"
                        state={{
                          customerId: item.customerId,
                        }}
                      >
                        <div>{item?.company || "N/A"}</div>
                        <div className="d-flex">
                          <i className="fa-solid fa-location-dot me-2"></i>
                          {item.city}
                        </div>
                      </Link>
                    </div>

                    <div className="dropdown">
                      <a
                        href="#"
                        className="text-dark"
                        data-bs-toggle="dropdown"
                      >
                        <i className="fa fa-ellipsis-v"></i>
                      </a>

                      <div className="dropdown-menu">
                        <Link
                          to="/view-customer"
                          className="dropdown-item"
                          state={{ customerId: item.customerId }}
                        >
                          <i className="fa-regular fa-eye me-2"></i>
                          View
                        </Link>

                        <Link
                          to="/view-customer"
                          className="dropdown-item"
                          state={{
                            customerId: item.customerId,
                            activeTab: "notes",
                          }}
                        >
                          <i className="fa-regular fa-note-sticky me-2"></i>
                          Note
                        </Link>

                        <Link
                          to="/view-customer"
                          className={`dropdown-item`}
                          state={{
                            customerId: item.customerId,
                            activeTab: "reminders",
                          }}
                        >
                          <i className="fa-solid fa-business-time me-2 text-info"></i>
                          Set Reminder
                        </Link>
                      </div>
                    </div>
                  </h5>

                  <div className="customer-details">
                    <div className="row g-2">
                      <div className="col-7">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-envelope  me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span className="text-truncat">
                            {item.email || "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="col-5">
                        <span className=" d-flex align-items-center">
                          <a href={`tel:${item.phonenumber}`} className="me-2">
                            <i className="fa-solid fa-phone"></i>
                          </a>

                          {item.phonenumber || "N/A"}
                          <a
                            href={`https://wa.me/${item.phonenumber?.replace(
                              /\D/g,
                              "",
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ms-2"
                          >
                            <i
                              className="fa-brands fa-whatsapp fa-lg"
                              style={{ color: "#25D366" }}
                            ></i>
                          </a>
                        </span>
                      </div>

                      <div className="col-7">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-user  me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.vat}>
                            {item.contactName && item.contactName.length > 20
                              ? item.contactName.substring(0, 20) + "..."
                              : item.contactName || "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="col-5">
                        <div className="d-flex align-items-center">
                          <span
                            className={`badge ${
                              item.active === 1 ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {item.active === 1 ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted">No data available</div>
        )}
      </div>

      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={filteredItems.length}
        paginate={paginate}
        currentPage={currentPage}
      />

      <Footer></Footer>
    </Base>
  );
}
